/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const dislikeDiets = useStore((state) => state.dislikeDiets);
  const setDislikeDiets = useStore((state) => state.setDislikeDiets);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dislikeDiets.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dislikeDiets}
          onChange={(value) => {
            setDislikeDiets(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'dislike-diets',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'restrictive'}>
            <span>🚫</span> {t('onboarding.dislikeDiets.options.restrictive')}
          </Option>
          <Option value={'hardToStick'}>
            <span>🕐</span> {t('onboarding.dislikeDiets.options.hardToStick')}
          </Option>
          <Option value={'boringFood'}>
            <span>🥱</span> {t('onboarding.dislikeDiets.options.boringFood')}
          </Option>
          <Option value={'guiltyAfterCheating'}>
            <span>😔</span> {t('onboarding.dislikeDiets.options.guiltyAfterCheating')}
          </Option>
          <Option value={'expensiveComplicated'}>
            <span>💸</span> {t('onboarding.dislikeDiets.options.expensiveComplicated')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
